"use client";

import AboutHero from "./AboutHero";
import WhoWeServe from "./WhoWeServe";
import Blogs from "@/components/home/Blogs"
import FAQSection from "./FAQSection"
import Team from "./Team";
import WhoWeAreSection from "./WhoWeAreSection";
import OurValuesSection from "./OurValuesSection";
import OurStorySection from "./OurStorySection";
import Testimonials from "./Testimonials";


export default function AboutClient() {
  return (
    <main>
      <AboutHero />
      <OurStorySection/>
      <WhoWeAreSection/>
      <WhoWeServe/>
      <OurValuesSection/>
      <Testimonials/>
      <Team/>
      <FAQSection/>
      <Blogs/>
    </main>
  );
}
